@if (isRmbRmc) {
<div>
  <span>{{ staticText | globalTranslate }}</span>
</div>
} @if (isRmbRmc && this.selectedIndividual) {
<div>
  <br />
</div>
} @if (getValue('extras.topLevelAnswer') === 'YES') {
<div form-top>
  <h1 class="person-label" [attr.aria-hidden]="!selectedIndividual ? 'true' : null">
    {{ selectedIndividual | fullname }}
  </h1>
</div>
}<br />
<nh-form
  [topLevelName]="'liq'"
  [individuals]="checkForDropdown ? finalListAll : individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  class="label-section"
  topLevelQuestion="{{ this.topLevelQuestion | globalTranslate }}"
  topLevelHintText="{{ topLevelQuestionHintText }}"
  individualQuestion="{{ this.individualQuestion | globalTranslate }}"
  hintText="{{ hintText }}"
  (validate)="onValidate($event)"
  (individualAnswerChanged)="onIndividualChange($event)"
>
  <section [formGroup]="getControl('data')">
    @if (!hideAssetType) {
    <div>
      <h2 class="section-header">
        {{ "FINANCIAL_RESOURCES_STATIC_TEXT1" | globalTranslate }}
      </h2>
      <hr />
      <nh-field
        id="liq_assetType"
        label="{{ 'FINANCIAL_RESOURCES_STATIC_TEXT2' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'FINANCIAL_RESOURCES_STATIC_TEXT3' | globalTranslate }}"
        class="label-section"
      >
        <div class="hint">
          {{ "IF" | globalTranslate }} {{ selectedIndividual | fullname }}
          {{ "FINANCIAL_RESOURCES_STATIC_TEXT4" | globalTranslate }}
        </div>
        <select
          nhTranslate
          aria-required="true"
          [attr.aria-label]="
            ('FINANCIAL_RESOURCES_STATIC_TEXT2' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('FINANCIAL_RESOURCES_STATIC_TEXT3' | globalTranslate)
          "
          name="assetType"
          (change)="onValueChange()"
          [items]="tableCodeValue('FINRESTYPE', 'data.assetType')"
          [attr.disabled]="this.exported ? true : null"
          formControlName="assetType"
        ></select>
      </nh-field>
    </div>
    }

    <div class="ps-1 pt-1 hover-red">
      <a
        class="btn btn-link hover-red"
        role="button"
        style="padding-left: 0"
        tabindex="0"
        (click)="financialModal()"
        (keydown.enter)="financialModal()"
        (keydown.space)="financialModal(); $event.preventDefault()"
      >
        <span class="pe-2">{{
          "FINANCIAL_RESOURCES_STATIC_TEXT5" | globalTranslate
        }}</span>
        <span
          ><i
            class="fa fa-external-link"
            aria-hidden="true"
            aria-label="popup"
          ></i
        ></span>
      </a>
    </div>

    <br />
    <div [formGroup]="getControl('data.trustInformation')">
      @if (isEnabled('data.trustInformation.trustType')) {
      <nh-field
        id="liq_trustType"
        label="{{ 'FINANCIAL_RESOURCES_STATIC_TEXT6' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="trustType"
          [attr.aria-label]="
            'FINANCIAL_RESOURCES_STATIC_TEXT6' | globalTranslate
          "
          formControlName="trustType"
          [items]="
            tableCodeValue('TRUSTTYPE', 'data.trustInformation.trustType')
          "
          aria-required="true"
        ></select>
      </nh-field>
      } @if (isEnabled('data.trustInformation.trusteeName')) {
      <nh-field
        id="liq_trusteeName"
        label="{{ 'FINANCIAL_RESOURCES_STATIC_TEXT7' | globalTranslate }}"
        class="label-section"
      >
        <input
          type="text"
          name="trusteeName"
          [attr.aria-label]="
            'FINANCIAL_RESOURCES_STATIC_TEXT7' | globalTranslate
          "
          formControlName="trusteeName"
          maxlength="20"
          class="form-control"
          aria-required="true"
        />
      </nh-field>
      } @if (isEnabled('data.trustInformation.beneficiaryOfTrust')) {
      <nh-field
        id="liq_beneficiaryOfTrust"
        label="{{ 'IS_1' | globalTranslate }}{{
          selectedIndividual | fullname
        }} {{ 'FINANCIAL_RESOURCES_STATIC_TEXT8' | globalTranslate }}"
        class="label-section"
      >
        <nh-popover
          class="ps-1"
          [content]="'FINANCIAL_RESOURCES_STATIC_TEXT9' | globalTranslate"
        ></nh-popover>
        <select
          nhTranslate
          name="beneficiaryOfTrust"
          [attr.aria-label]="
            ('IS_1' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('FINANCIAL_RESOURCES_STATIC_TEXT8' | globalTranslate) +
            ' ' +
            ('FINANCIAL_RESOURCES_STATIC_TEXT9' | globalTranslate)
          "
          formControlName="beneficiaryOfTrust"
          [items]="
            tableCodeValue('YESNO', 'data.trustInformation.beneficiaryOfTrust')
          "
          aria-required="true"
        ></select>
      </nh-field>
      } @if (isEnabled('data.trustInformation.ownTrust')) {
      <nh-field
        id="liq_ownTrust"
        label="{{ 'FINANCIAL_RESOURCES_STATIC_TEXT10' | globalTranslate }} {{
          selectedIndividual | fullname
        }}?"
        class="label-section"
      >
        <select
          nhTranslate
          name="ownTrust"
          [attr.aria-label]="
            ('FINANCIAL_RESOURCES_STATIC_TEXT10' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname)
          "
          formControlName="ownTrust"
          [items]="tableCodeValue('YESNO', 'data.trustInformation.ownTrust')"
          aria-required="true"
        ></select>
      </nh-field>
      }
    </div>

    @if (isEnabled('data.retireOrJobEnd')) {
    <nh-field
      id="liq_retireOrJobEnd"
      label="{{ 'DOES_2' | globalTranslate }}{{
        selectedIndividual | fullname
      }} {{ 'FINANCIAL_RESOURCES_STATIC_TEXT11' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="retireOrJobEnd"
        [attr.aria-label]="
          ('DOES_2' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('FINANCIAL_RESOURCES_STATIC_TEXT11' | globalTranslate)
        "
        formControlName="retireOrJobEnd"
        [items]="tableCodeValue('YESNO', 'data.retireOrJobEnd')"
        aria-required="true"
      ></select>
    </nh-field>
    } @if (isEnabled('data.beneficiaryOrDonor')) {
    <nh-field
      id="liq_beneficiaryOrDonor"
      label="{{ 'IS_1' | globalTranslate }}{{
        selectedIndividual | fullname
      }} {{ 'FINANCIAL_RESOURCES_STATIC_TEXT12' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="beneficiaryOrDonor"
        [attr.aria-label]="
          ('IS_1' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('FINANCIAL_RESOURCES_STATIC_TEXT12' | globalTranslate)
        "
        formControlName="beneficiaryOrDonor"
        [items]="tableCodeValue('BNDN', 'data.beneficiaryOrDonor')"
        aria-required="true"
      ></select>
    </nh-field>
    } @if (isEnabled('data.assetAmount')) {
    <nh-field
      id="liq_assetAmount"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'FINANCIAL_RESOURCES_STATIC_TEXT13' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'FINANCIAL_RESOURCES_STATIC_TEXT14' | globalTranslate }}{{
        getValue('data.assetType').value === 'CC' ||
        getValue('data.assetType').value === 'CIA'
          ? ''
          : (getValue('data.assetType').value | globalTranslate)
      }}?"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="text"
          placeholder="0.00"
          mask="separator.2"
          thousandSeparator=""
          separatorLimit="999999999"
          name="assetAmount"
          [attr.aria-label]="
            ('FINANCIAL_RESOURCES_STATIC_TEXT13' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('FINANCIAL_RESOURCES_STATIC_TEXT14' | globalTranslate) +
            ' ' +
            (getValue('data.assetType').value === 'CC' ||
            getValue('data.assetType').value === 'CIA'
              ? ''
              : (getValue('data.assetType').value | globalTranslate))
          "
          formControlName="assetAmount"
          class="form-control"
        />
      </nh-input-group>
    </nh-field>
    }

    <div [formGroup]="getControl('data.accountInformation')">
      @if (this.translatedLang === 'en') {
      <div>
        @if (isEnabled('data.accountInformation.accountNumber')) {
        <nh-field
          id="liq_accountNumber"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'FINANCIAL_RESOURCES_STATIC_TEXT15' | globalTranslate }} {{
            selectedIndividual | fullname
          }}{{ 'APOSTROPHE_S' | globalTranslate }} {{
            getValue('data.assetType').value === 'CC' ||
            getValue('data.assetType').value === 'CIA'
              ? ''
              : (getValue('data.assetType').value | globalTranslate)
          }} {{ 'ACCOUNT_NUMBER' | globalTranslate }}?"
          class="label-section"
        >
          <input
            type="text"
            name="accountNumber"
            [attr.aria-label]="
              ('FINANCIAL_RESOURCES_STATIC_TEXT15' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              (getValue('data.assetType').value === 'CC' ||
              getValue('data.assetType').value === 'CIA'
                ? ''
                : (getValue('data.assetType').value | globalTranslate))
            "
            formControlName="accountNumber"
            class="form-control"
            maxlength="20"
          />
        </nh-field>
        }
      </div>
      } @if (this.translatedLang !== 'en') {
      <div>
        @if (isEnabled('data.accountInformation.accountNumber')) {
        <nh-field
          id="liq_accountNumber"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'FINANCIAL_RESOURCES_STATIC_TEXT15' | globalTranslate }} {{
            getValue('data.assetType').value === 'CC' ||
            getValue('data.assetType').value === 'CIA'
              ? ''
              : (getValue('data.assetType').value | globalTranslate)
          }} de {{ selectedIndividual | fullname }}?"
          class="label-section"
        >
          <input
            type="text"
            name="accountNumber"
            [attr.aria-label]="
              ('FINANCIAL_RESOURCES_STATIC_TEXT15' | globalTranslate) +
              ' ' +
              (getValue('data.assetType').value === 'CC' ||
              getValue('data.assetType').value === 'CIA'
                ? ''
                : (getValue('data.assetType').value | globalTranslate)) +
              ' ' +
              (selectedIndividual | fullname)
            "
            formControlName="accountNumber"
            class="form-control"
            maxlength="20"
          />
        </nh-field>
        }
      </div>
      } @if (showBankSearch) {
      <nh-search
        [applicationNumber]="applicationNumber"
        keyword="bank"
        resource="banks"
        [searchOnOpen]="true"
        [columns]="resultsColumns"
        [searchGroup]="getControl('extras.helpers.search')"
        [showSearchButton]="false"
        [showSearch]="true"
        [sectionId]="'ASLIQ'"
        (row)="selectItem($event)"
        (reset)="deleteItem()"
        (search)="searchHandler()"
        selectColumn="true"
      >
        <ng-container
          search-form
          [formGroup]="getControl('extras.helpers.search')"
        >
          @if (isEnabled('extras.helpers.search.bankName')) {
          <div>
            <h2 class="section-header">
              {{ "FINANCIAL_RESOURCES_STATIC_TEXT16" | globalTranslate }}
            </h2>
            <hr />
          </div>
          } @if (isEnabled('extras.helpers.search.bankName')) {
          <nh-field
            id="liq_bankName"
            [mandatory]="true"
            [attr.aria-required]="true"
            label="{{ 'FINANCIAL_RESOURCES_STATIC_TEXT17' | globalTranslate }}"
            class="label-section"
          >
            <input
              type="text"
              name="bankName"
              formControlName="bankName"
              [attr.aria-label]="
                'FINANCIAL_RESOURCES_STATIC_TEXT17' | globalTranslate
              "
              class="form-control"
              [maxlength]="bankNameLength"
              [required]="isEnabled('extras.helpers.search.bankName')"
            />
          </nh-field>
          }
          <div class="row">
            <div class="col-12 col-md-4">
              <nh-field
                id="liq_state"
                [isRow]="true"
                [mandatory]="true"
                [attr.aria-required]="false"
                label="{{ 'STATE' | globalTranslate }}"
                class="label-section"
              >
                <select
                  nh
                  name="state"
                  [attr.aria-label]="'STATE' | globalTranslate"
                  [items]="tables.STATE"
                  bindValue="code"
                  formControlName="state"
                  [required]="isEnabled('extras.helpers.search.bankName')"
                ></select>
              </nh-field>
            </div>
            <div class="col-12 col-md-4">
              <nh-field
                id="liq_zipCode"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="{{ 'ZIP_CODE' | globalTranslate }}"
                class="label-section"
              >
                <input
                  type="text"
                  name="zipCode"
                  [attr.aria-label]="'ZIP_CODE' | globalTranslate"
                  formControlName="zipCode"
                  mask="00000-0000"
                  [validation]="false"
                  placeholder="XXXXX-XXXX"
                  class="form-control"
                />
              </nh-field>
            </div>
          </div>
        </ng-container>
      </nh-search>
      } @if (showBankAddress) {
      <nh-field
        id="liq_bankName"
        [mandatory]="true"
        [attr.aria-required]="true"
        label="{{ 'FINANCIAL_RESOURCES_STATIC_TEXT18' | globalTranslate }}"
        formGroupName="bankSearch"
        search-field
        class="label-section"
      >
        <input
          type="text"
          name="bankName"
          formControlName="bankName"
          [attr.aria-label]="
            'FINANCIAL_RESOURCES_STATIC_TEXT18' | globalTranslate
          "
          class="form-control"
          [maxlength]="bankNameLength"
          [attr.disabled]="isAddressDisabled ? true : null"
          [required]="true"
        />
      </nh-field>
      } @if (showBankAddress &&
      hasValue('data.accountInformation.bankSearch.bankName')) {
      <nh-name-address
        [addressname]="'liq_bankName'"
        [address]="getControl('data.assetAddress')"
        [stateDefault]="false"
        [showPopup]="false"
        [isAssistingPerson]="true"
        [tables]="tables"
        [addressFieldMandatory]="false"
        [isDisabled]="isAddressDisabled"
      ></nh-name-address>
      }
    </div>
    <br />

    @if (selectedIndividual) {
    <div>
      <h2 class="section-header">
        {{ "CO-OWENERS_TITLE" | globalTranslate }}
      </h2>
      <hr />
      <nh-field
        id="liq_jointOwnership"
        label="{{ 'FINANCIAL_RESOURCES_STATIC_TEXT19' | globalTranslate }} {{
          getValue('data.assetType').value === 'CC' ||
          getValue('data.assetType').value === 'CIA'
            ? ''
            : (getValue('data.assetType').value | globalTranslate)
        }} {{ 'FINANCIAL_RESOURCES_STATIC_TEXT20' | globalTranslate }} {{
          selectedIndividual | fullname
        }}? "
        class="label-section"
      >
        <div class="hint">
          {{ "FINANCIAL_RESOURCES_STATIC_TEXT21" | globalTranslate }}
          {{ selectedIndividual | fullname }}
          {{ "FINANCIAL_RESOURCES_STATIC_TEXT22" | globalTranslate }}
        </div>
        <select
          nhTranslate
          name="jointOwnership"
          [attr.aria-label]="
            ('FINANCIAL_RESOURCES_STATIC_TEXT19' | globalTranslate) +
            ' ' +
            (getValue('data.assetType').value === 'CC' ||
            getValue('data.assetType').value === 'CIA'
              ? ''
              : (getValue('data.assetType').value | globalTranslate)) +
            ' ' +
            ('FINANCIAL_RESOURCES_STATIC_TEXT20' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('FINANCIAL_RESOURCES_STATIC_TEXT21' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            '' +
            ('FINANCIAL_RESOURCES_STATIC_TEXT22' | globalTranslate)
          "
          [items]="tableCodeValue('YESNO', 'data.jointOwnership')"
          formControlName="jointOwnership"
          aria-required="true"
        ></select>
      </nh-field>
      @if (isY('data.jointOwnership')) {
      <div>
        <nh-co-owner
          [jointOwnershipInformation]="
            getControl('data.jointOwnershipInformation')
          "
          [coOwnerIndivErrorMessage]="coOwnerIndivErrorMessage"
          [formData]="getControl('data')"
          [addRowValid]="checkValid()"
          [coOwnerIndividuals]="coOwnerIndividuals"
          [error]="error"
          (emitValidate)="coOwnerValidate($event)"
          (errorMessage)="getErrorMessage($event)"
          (removeRow)="removeRow($event)"
          (addRow)="addRow()"
        ></nh-co-owner>
      </div>
      }
    </div>
    }
  </section>
</nh-form>